<template>
    <v-dialog fullscreen persistent v-model="getModalCadastroContaPagar">
        <v-card outlined :loading="$store.getters.getOverlay">
            <v-card-title>
                Cadastro de Conta a Pagar
            </v-card-title>
            <v-form class="px-3" ref="form">
                <v-card-text>
                    <v-layout row wrap>
                        <v-flex xs12 md8>
                            <v-autocomplete class="mr-2 ml-2" v-model="getContaPagar.fornecedor_id" :items="getContatos"
                                item-text="nome" item-value="id" outlined dense append-outer-icon="control_point"
                                @click:append-outer="cadastrarContato" label="Fornecedor/Cliente" :rules="rules.fornecedor_id"></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 md4>
                            <v-text-field label="Nº do Documento" outlined dense class="mr-2 ml-2"
                                v-model="getContaPagar.numero_documento"></v-text-field>
                        </v-flex>
                        <v-flex xs12 md2>
                            <v-select class="mr-2 ml-2" :items="getContaPagarSituacoes" v-model="getContaPagar.situacao"
                                label="Situação" outlined dense :rules="rules.situacao" readonly></v-select>
                        </v-flex>
                        <v-flex xs12 md3>
                            <v-text-field label="Data de Vencimento" outlined dense class="mr-2 ml-2"
                                v-model="getContaPagar.data_vencimento" type="date" :rules="rules.data_vencimento"></v-text-field>
                        </v-flex>
                        <v-flex xs12 md3>
                            <v-text-field label="Data de Emissão" outlined dense class="mr-2 ml-2"
                                v-model="getContaPagar.data_emissao" type="date"></v-text-field>
                        </v-flex>
                        <v-flex xs12 md3>
                            <v-text-field label="Data de Pagamento" outlined dense class="mr-2 ml-2"
                                v-model="getContaPagar.data_pagamento" type="date"></v-text-field>
                        </v-flex>
                        <v-flex xs12 md1>
                            <v-text-field label="Valor" outlined dense class="mr-2 ml-2" v-model="getContaPagar.valor"
                                v-mask="['#,##', '##,##', '###,###', '#.###,##', '##.###,##', '###.###,##']" valor
                                :rules="rules.valor">
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12 md3>
                            <v-select :items="getContaPagarFormasPagamento" v-model="getContaPagar.forma_pagamento"
                                label="Forma de Pagamento" outlined dense class="mr-2 ml-2" :rules="rules.forma_pagamento"></v-select>
                        </v-flex>
                        <v-flex xs12 md3>
                            <v-select :items="getPortadoresFinanceiro" v-model="getContaPagar.portador_id" item-text="nome" item-value="id" label="Portador"
                                outlined dense class="mr-2 ml-2" append-outer-icon="control_point"
                                @click:append-outer="setModalListarPortadorFinanceiro(true)"></v-select>
                        </v-flex>
                        <v-flex xs12 md3>
                            <v-autocomplete class="mr-2 ml-2" v-model="getContaPagar.grupo_id"
                                :items="getGruposFinanceiro" item-text="nome" item-value="id" label="Categoria"
                                outlined dense append-outer-icon="control_point"
                                @click:append-outer="cadastrarGrupoFinanceiro"></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 md3>
                            <v-select :items="getContaPagarOcorrenciaTipos" v-model="getContaPagar.ocorrencia_tipo"
                                label="Tipo Ocorrência" outlined dense class="mr-2 ml-2" :rules="rules.ocorrencia_tipo"></v-select>
                        </v-flex>
                        <v-flex xs12 md6 v-if="getContaPagar.ocorrencia_tipo != 'PARCELA ÚNICA'">
                            <v-select :items="getContaPagarOcorrencias" v-model="getContaPagar.ocorrencia"
                                label="Ocorrência" outlined dense class="mr-2 ml-2" :rules="rules.ocorrencia"></v-select>
                        </v-flex>
                        <v-flex xs12 md6 v-if="getContaPagar.ocorrencia_tipo != 'PARCELA ÚNICA'">
                            <v-text-field label="Ocorrência (Vezes)" v-model="getContaPagar.ocorrencia_quantidade"
                                outlined dense class="mr-2 ml-2" type="number" :rules="rules.ocorrencia_quantidade"></v-text-field>
                        </v-flex>
                        <v-flex xs12 md12>
                            <v-textarea label="Informações" outlined dense class="mr-2 ml-2" v-model="getContaPagar.informacoes"></v-textarea>
                        </v-flex>
                        <v-flex xs12 md12>
                            <v-file-input label="Anexo" v-if="getShowInputAnexo" @change="selecionaAnexo" outlined dense
                                class="mr-2 ml-2"></v-file-input>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="default" @click="setModalCadastroContaPagar(false)" outlined>Voltar</v-btn>
                    <v-btn color="primary" outlined @click="cadastrarContaPagar" v-if="getContaPagar.id && $helper.verificaPermissao('cadastrar-conta-pagar')">Novo</v-btn>
                    <v-btn color="error" outlined @click="setModalExcluirContaPagar(true)" v-if="getContaPagar.id && $helper.verificaPermissao('cadastrar-conta-pagar')">
                        Excluir</v-btn>
                    <a v-if="getContaPagar.anexo" :href="getContaPagar.anexo" target="_blank"><v-btn color="default" class="mr-2 ml-2" outlined>Visualizar Anexo</v-btn></a>
                    <v-btn v-if="getContaPagar.situacao == 'EM ABERTO' && $helper.verificaPermissao('baixar-conta-pagar') && getContaPagar.id" class="ml-2" color="success" outlined
                            @click="setModalBaixaContaPagar(true)">Baixar</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn v-if="getContaPagar.situacao != 'PAGO' && ($helper.verificaPermissao('cadastrar-conta-pagar') || $helper.verificaPermissao('atualizar-conta-pagar'))" color="success" @click="salvar" outlined>Salvar</v-btn>
                </v-card-actions>
            </v-form>
        </v-card>

        <ModalExcluir />
        <!-- <ModalpesquisarContato /> -->
        <ModalCadastroContato />
        <ModalListarPortador />
        <ModalCadastroGrupo />
    </v-dialog>
</template>

<script>
    import ModalExcluir from "@/pages/financeiro/contaPagar/ModalExcluir"
    // import ModalpesquisarContato from '@/pages/contato/ModalPesquisar'
    import ModalCadastroContato from '@/pages/contato/ModalCadastro'
    import ModalListarPortador from '@/pages/financeiro/portador/Listar'
    import ModalCadastroGrupo from '@/pages/financeiro/grupo/ModalCadastro'
    import { mapGetters, mapActions } from 'vuex'
    export default {
        data(){
            return { 
                rules: {
                    fornecedor_id: [
                        v => !!v || 'Campo obrigatório.'
                    ],
                    situacao: [
                        v => !!v || 'Campo obrigatório.'
                    ],
                    data_vencimento: [
                        v => !!v || 'Campo obrigatório.'
                    ],
                    valor: [
                        v => !!v || 'Campo obrigatório.'
                    ],
                    forma_pagamento: [
                        v => !!v || 'Campo obrigatório.'
                    ],
                    numero_parcela: [
                        v => !!v || 'Campo obrigatório.'
                    ],
                    ocorrencia_tipo: [
                        v => !!v || 'Campo obrigatório.'
                    ],
                    ocorrencia: [
                        v => !!v || 'Campo obrigatório.'
                    ],
                    ocorrencia_quantidade: [
                        v => !!v || 'Campo obrigatório.'
                    ],

                }
            }
        },
        components: {
            ModalExcluir,
            // ModalpesquisarContato,
            ModalCadastroContato,
            ModalListarPortador,
            ModalCadastroGrupo,
        },
        watch: {
            getModalCadastroContaPagar(){
                if(this.getModalCadastroContaPagar){
                    this.listarContatos({
                        pagina: 1,
                        id: "",
                        nome: "",
                        tipo: "",
                        cpf_cnpj: "",
                        cidade: "",
                        telefone: "",
                        limit: "",
                    });
                }
            }
        },
        computed: {
            ...mapGetters([
                'getContaPagar',
                'getModalCadastroContaPagar',
                'getContaPagarFormasPagamento',
                'getContaPagarSituacoes',
                'getContatos',
                'getContaPagarPortadores',
                'getGruposFinanceiro',
                'getContaPagarOcorrencias',
                'getContaPagarOcorrenciaTipos',
                'getShowInputAnexo',
                'getPortadoresFinanceiro',
            ])
        },

        methods: {
            ...mapActions([
                'setModalCadastroContaPagar',
                'setModalExcluirContaPagar',
                'cadastrarContaPagar',
                'salvarContaPagar',
                'atualizarContaPagar',
                'setModalPesquisarContato',
                'listarContatos',
                'cadastrarContato',
                'listarGrupoFinanceiro',
                'cadastrarGrupoFinanceiro',
                'setModalListarPortadorFinanceiro',
                'listarPortadorFinanceiro',
                'setModalBaixaContaPagar'
                
            ]),
            salvar() {
                if(this.$refs.form.validate() === false){
                    return
                }

                const form = new FormData;
                if(this.getContaPagar.fornecedor_id){
                    form.append('fornecedor_id', this.getContaPagar.fornecedor_id)
                }
                if(this.getContaPagar.situacao){
                    form.append('situacao', this.getContaPagar.situacao)
                }
                if(this.getContaPagar.numero_documento){
                    form.append('numero_documento', this.getContaPagar.numero_documento)
                }
                if(this.getContaPagar.data_emissao){
                    form.append('data_vencimento', this.getContaPagar.data_vencimento)
                }
                if(this.getContaPagar.data_emissao){
                    form.append('data_emissao', this.getContaPagar.data_emissao)
                }
                if(this.getContaPagar.data_pagamento){
                    form.append('data_pagamento', this.getContaPagar.data_pagamento)
                }
                if(this.getContaPagar.valor){
                    form.append('valor', this.getContaPagar.valor)
                }
                if(this.getContaPagar.forma_pagamento){
                    form.append('forma_pagamento', this.getContaPagar.forma_pagamento)
                }
                if(this.getContaPagar.ocorrencia_tipo){
                    form.append('ocorrencia_tipo', this.getContaPagar.ocorrencia_tipo)
                }
                if(this.getContaPagar.ocorrencia){
                    form.append('ocorrencia', this.getContaPagar.ocorrencia)
                }
                if(this.getContaPagar.ocorrencia_quantidade){
                    form.append('ocorrencia_quantidade', this.getContaPagar.ocorrencia_quantidade)
                }
                if(this.getContaPagar.numero_parcela){
                    form.append('numero_parcela', this.getContaPagar.numero_parcela)
                }
                if(this.getContaPagar.ocorrencia_quantidade){
                    form.append('ocorrencia_quantidade', this.getContaPagar.ocorrencia_quantidade)
                }
                if(this.getContaPagar.informacoes){
                    form.append('informacoes', this.getContaPagar.informacoes)
                }
                if(this.getContaPagar.anexo){
                    form.append('anexo', this.getContaPagar.anexo)
                }
                if(this.getContaPagar.portador_id){
                    form.append('portador_id', this.getContaPagar.portador_id)
                }
                if(this.getContaPagar.grupo_id){
                    form.append('grupo_id', this.getContaPagar.grupo_id)
                }

                if (this.getContaPagar.id) {
                    form.append('_method', 'PUT')
                    form.append('id', this.getContaPagar.id)
                    this.atualizarContaPagar(form)
                } else {
                    this.salvarContaPagar(form)
                }
            },
            selecionaAnexo(e) {
                this.getContaPagar.anexo = e
            }
        },
        created() {
            this.listarGrupoFinanceiro()
            this.listarPortadorFinanceiro()
        }
    }
</script>